<template>
    <v-btn flat @click="$i18n.locale = locale_computed">{{locale_computed2}}</v-btn>
    <!-- <v-select :items="langs" item-text="text" single-line v-model="$i18n.locale" ></v-select> -->
    
    <!-- <v-elect v-model=
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
    </select> -->
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: [{value: 'pt_BR', text: 'Português'},{value: 'en', text: 'English'} ] }
  },
  computed: {
    locale_computed() {
      return this.$i18n.locale == 'en'? 'pt_BR' : 'en' 
    },
    locale_computed2() {
      return this.$i18n.locale == 'en'? 'pt' : 'en' 
    }
  },
}
</script>